import { useState } from 'react';
import { pbBaseUrl } from '../lib/pbBaseUrl';
import type { Attachment } from '../lib/staffClient';

const src = (url: string) => (url.startsWith('http') ? url : `${pbBaseUrl()}${url}`);

/**
 * Photos, GIFs and videos attached to a piece of reported/audited content.
 * `hidden` puts them behind a click — used for illegal-content reports so staff
 * never see potentially abusive media by accident (runbook §5).
 */
export function Attachments({ items, hidden = false }: { items: Attachment[]; hidden?: boolean }) {
  const [shown, setShown] = useState(!hidden);
  if (items.length === 0) return null;
  if (!shown)
    return (
      <button className="btn btn--ghost" onClick={() => setShown(true)}>
        Show {items.length} attachment{items.length === 1 ? '' : 's'}
      </button>
    );
  return (
    <div className="attach-grid">
      {items.map((a) =>
        a.kind === 'video' ? (
          <video key={a.url} className="attach-item" src={src(a.url)} controls preload="none" />
        ) : (
          <a key={a.url} href={src(a.url)} target="_blank" rel="noopener noreferrer">
            <img
              className="attach-item"
              src={src(a.url)}
              alt={`${a.kind} attachment`}
              loading="lazy"
            />
          </a>
        ),
      )}
    </div>
  );
}
